export const ALLERGIES_URL = '/api/pet/null/allergies';

export const getPlaceholderAllergies = (count = 8) =>
  Array(count)
    .fill({ name: 'Loading' })
    .map((value, index) => ({ ...value, id: `Loading-${index}` }));
